import { render } from "./LicensedDevicesTable.vue?vue&type=template&id=12bdef70&scoped=true"
import script from "./LicensedDevicesTable.vue?vue&type=script&lang=js"
export * from "./LicensedDevicesTable.vue?vue&type=script&lang=js"

import "./LicensedDevicesTable.vue?vue&type=style&index=0&id=12bdef70&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12bdef70"]])

export default __exports__